import { useMutation, useQueryClient } from '@tanstack/react-query';

import APIGateway from '@/api';
import { apiKeysKeys } from '@/hooks/queries/useApiKeys';
import { CreateApiKeyReq } from '@/types/apiKey';


export function useCreateApiKey() {
  const queryClient = useQueryClient();

  return useMutation( {
    mutationFn: async( req: CreateApiKeyReq ) => {
      return await APIGateway.apiKeys.apiKeyCreateScoped( req );
    },
    onSuccess: () => {
      queryClient.invalidateQueries( { queryKey: apiKeysKeys.all } );
    }
  } );
}

export function useDeleteApiKey() {
  const queryClient = useQueryClient();

  return useMutation( {
    mutationFn: async( keyId: string ) => {
      return await APIGateway.apiKeys.apiKeyDeleteScoped( keyId );
    },
    onSuccess: () => {
      queryClient.invalidateQueries( { queryKey: apiKeysKeys.all } );
    }
  } );
}

export function useEnableApiKey() {
  const queryClient = useQueryClient();

  return useMutation( {
    mutationFn: async( keyId: string ) => {
      return await APIGateway.apiKeys.apiKeyEnableScoped( keyId );
    },
    onSuccess: () => {
      queryClient.invalidateQueries( { queryKey: apiKeysKeys.all } );
    }
  } );
}

export function useDisableApiKey() {
  const queryClient = useQueryClient();

  return useMutation( {
    mutationFn: async( keyId: string ) => {
      return await APIGateway.apiKeys.apiKeyDisableScoped( keyId );
    },
    onSuccess: () => {
      queryClient.invalidateQueries( { queryKey: apiKeysKeys.all } );
    }
  } );
}
